

















import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {buildRequestHeader} from "@/shared/services/helper/utils";

@Component({
    name: "UploadDocument"
})

export default class extends Vue {
    @Model("change")
    readonly filePath!: string;

    @Emit('change')
    handleChange(info: any) {
        if (info.file.status == "done") {
            const url = info?.file?.response?.data.path;
            if(url != null) {
                return url
            }
        }
        return "";
    }

    headers = buildRequestHeader(false as any);
    action = `${process.env.VUE_APP_BASE_API}v1/upload/by-file`;
    params = {
        folder: "excel"
    };
}
